import { security } from "./security";
import { isEmbeddedMode } from "../utils/embeddedMode";

export const GetBearerToken = async () => {
  try {
    return await security.getAccessTokenSilently()({});
  } catch (e) {
    console.log(e);
    if (typeof window !== "undefined") {
      // In embedded mode, don't redirect - let API calls fail gracefully
      // User stays on page with ?embedded=true preserved and can use the
      // "Access Customer Experience directly" link to re-authenticate
      if (isEmbeddedMode()) {
        return undefined;
      }
      (window as any).location.href = "/logout";
    }
  }
};
